<div id="plans-container" class="plans-column">
    <ng-scrollbar [visibility]="'hover'">
        <div class="plans-container">
            <ul id="plans-list">
                @for (plan of plans(); track plan.planId; let i = $index) {
                    <li>
                        <a class="btn-plan" (click)="onSelectedPlanChanged(plan.planId)" id="plan-{{ i }}">
                            <div
                                id="plan-preview-{{ i }}"
                                class="plan-container"
                                [ngClass]="{ selected: selected_iD_Plan() === plan.planId }">
                                <div class="plan-label" [title]="plan.planLabel">{{ plan.planLabel }}</div>
                                @if (!plan.hScale && !plan.vScale) {
                                    <div class="not-scaled">Not scaled</div>
                                } @else {
                                    <p class="scaled">
                                        {{ !plan.originalPlan.ScaleRatio ? 'Manual' : plan.originalPlan.ScaleRatio }}
                                    </p>
                                }
                            </div>
                        </a>
                    </li>
                }
            </ul>
        </div>
    </ng-scrollbar>
</div>
